'use client'

import { Animation, Cell, EmptyState } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/shared/i18n'
import { useAsset } from '@marketplace-web/domain/assets'

const ConversationListEmptyState = () => {
  const asset = useAsset('/assets/conversation/list')
  const translate = useTranslate('conversations.list')

  return (
    <Cell>
      <EmptyState
        title={translate('empty_state.title')}
        body={translate('empty_state.body')}
        animation={
          <Animation
            animationUrl={asset('envelope-empty-state.json')}
            aria={{ 'aria-hidden': 'true' }}
          />
        }
        testId="conversation-list--empty-state"
      />
    </Cell>
  )
}

export default ConversationListEmptyState
